export default "__VITE_ASSET__B5GRM$1m__"